export var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
};
export var getPercentage = function (value, min, max) {
    return ((value - min) / (max - min)) * 100;
};
export var getValueFromPosition = function (position, trackRect, min, max, step) {
    var percentage = Math.max(0, Math.min(100, (position / trackRect.width) * 100));
    var rawValue = (percentage / 100) * (max - min) + min;
    return Math.round(rawValue / step) * step;
};
